// import { showIndex } from "../include/module";
// import { anchorLink } from "../include/module";
//
//
// (() => {
//
//   showIndex();
//   anchorLink();
//
// })();

//preload
import {preload} from "../include/module";
preload();

//checkSP
import {checkSP} from "../include/module";
checkSP();

//ローディング
import {showIndex} from "../include/module";
showIndex();

//bgAnime
import {bgAnime} from "../include/module";
bgAnime();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//showTtl
import {showTtl} from "../include/module";
showTtl();



// WEBPACK FOOTER //
// ./src/bangdream_3rd_v0/assets/js/index/script.js